import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

const cylinderOptions: Record<number, string> = {
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  8: 'eight',
  10: 'ten',
  12: 'twelve',
};

export default function CylindersTapEvent(numCyls: number, sourcePage: SourcePages): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage === SourcePages.Srp ? SourcePages.SrpFilter : SourcePages.SeoSrpFilter,
    feature: Features.cylinders,
    engagement_type: `${cylinderOptions[numCyls]}_tap`,
    event_context: {},
  };
}
